export default __webpack_public_path__ + "static/treatmentareas_underarmbefore-d769c2673aa03d75084530fd95f23464.webp";